// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__hcXUG","corona":"App_corona__3wghn"};